import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import TableSkeleton from '../Shared/Table/Skeleton';

const MasterySkeleton = () => {
  return (
    <>
      <div className='flex justify-between items-center max-w-5xl gap-4 mx-auto mt-6 mb-10 px-5 max-sm:flex-col'>
        <div className='flex w-full max-w-2xl items-center rounded-md'>
          <Skeleton width={672} height={60.5} style={{ lineHeight: 'unset' }} />
        </div>
        <div className='max-w-[326px] w-full max-sm:max-w-full'>
          <Skeleton height={60.5} className='w-full max-sm:max-h-11' style={{ lineHeight: 'unset' }} />
        </div>
      </div>
      <TableSkeleton />
    </>
  );
};

export default MasterySkeleton;
